import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-departments',
  templateUrl: './helpbutton-departments.component.html',
  styleUrls: ['./helpbutton-departments.component.scss']
})
export class HelpbuttonDepartmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
